// import dataPricePort from '../components/dataPort/dataPricePort.vue'
// import dataWeekPort from '../components/dataPort/dataWeekPort.vue'
// import dataMonthProt from '../components/dataPort/dataMonthProt.vue'

export default [
    { 
        path: 'dataPort/dataPricePort',
        component: resolve => require(['@/components/dataPort/dataPricePort'],resolve),
        name:'DataPricePort',
        meta:{
            id:'510',
            node:'dataPort',
            url:'dataPricePort',
        }
    },
    { 
        path: 'dataPort/dataWeekPort',
        component: resolve => require(['@/components/dataPort/dataWeekPort'],resolve),
        name:'DataWeekPort',
        meta:{
            id:'511',
            node:'dataPort',
            url:'dataWeekPort',
        }
    },
    { 
        path: 'dataPort/dataMonthProt',
        component: resolve => require(['@/components/dataPort/dataMonthProt'],resolve),
        name:'DataMonthProt',
        meta:{
            id:'798',
            node:'dataPort',
            url:'dataMonthProt',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/dataPort.js